<template>
  <div class="bread-crumb" v-if="courseInfoModule && Object.keys(courseInfoModule).length">
    <ol>
      <li>
        <a href="https://online.xueersi.com/select-course">选课中心</a>
      </li>
      <li>
        <router-link
          :to="{
            name: 'course-center',
            params: { courseType: courseInfoModule.courseType, grade: courseInfoModule.gradeIds, subject: courseInfoModule.subjectIds }
          }"
          >{{ courseTypeNameCH[String(courseInfoModule.courseType)] }}</router-link
        >
      </li>
      <!-- <li>
        <router-link :to="{name: 'course-center', params: {courseType: courseDetail.courseType, grade, subject: subject}}">{{subjectName}}</router-link>
      </li> -->
      <li v-html="xss(courseInfoModule.courseName)"></li>
    </ol>
  </div>
</template>

<script>
import xss from 'xss'

export default {
  name: 'bread-crumb',
  props: {
    courseInfoModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      courseTypeNameCH: {
        '2742': '启蒙拓展',
        '-23': '同步课列表',
        '-24': '专题课列表',
        '-25': '10分钟素养课列表',
        '-26': '三节课列表',
        '-1600': '大师课',
        '2242' : '家长课'
      },
      xss
    }
  },
  computed: {
    grade() {
      const userGrade = this.$store.state.cookies.currentGrade
        ? this.$store.state.cookies.currentGrade
        : 4
      return userGrade
    },
    subject() {
      if (Number(this.courseInfoModule.courseType) === -25) {
        return -925
      }
      return 0
    },
    subjectName() {
      return this.courseInfoModule.subjects[0].type_2_tag_name || '全部'
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #afafaf;
}
a:hover {
  color: #666;
}
.bread-crumb {
  font-size: 12px;
  line-height: 16px;
  width: 1200px;
  ol {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  padding: 20px 0;
  li {
    float: left;
  }
  li + li:before {
    content: '>';
    color: #999999;
    width: 3px;
    height: 4px;
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/BreadCrumb.vue